import React from 'react';
import { Poppins } from 'src/common';
import Input from '../../form/Input';
import * as S from './ExportAccessToggle.styles';

interface ExportAccessToggleProps {
  value: boolean;
  onChange: (next: boolean) => void;
}

// Per iteration 1 spec (wiki/notes/report-centre.md): the user can mark a
// generated report as private (only visible to themselves) or shared with the
// entire workspace. Default = workspace-shared. The boolean is mapped to the
// BE's `ExportAccess` enum (USER | WORKSPACE) inside useExportJob.ts.
export const ExportAccessToggle: React.FC<ExportAccessToggleProps> = ({ value, onChange }) => (
  <S.Row>
    <Poppins className="question">Make this report public for the entire workspace?</Poppins>
    <div className="toggle">
      <span>No</span>
      <Input
        checked={value}
        onChange={(e) => onChange(e.target.checked)}
        className="switch"
        type="checkbox"
        data-cy="export-access-toggle"
      />
      <span>Yes</span>
    </div>
  </S.Row>
);
